import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/advisorsPage/pages/Advisors'

import { AdvisorsListRoutePathsEnum } from './advisorsListRouteConfig.types'

export const ADVISORS_LIST_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: AdvisorsListRoutePathsEnum.ADVISORS_LIST,
  },
]
